import { type ReactNode, useEffect } from 'react';
import { Icon, Slider } from 'ui';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- TODO: fix according to result of #67489
import { useIsChannelEmpty } from 'features/channels/hooks';
import type { VideosListFilter } from '../../models';
import { VideoCard } from '../video-card';
import { useVideos } from './hooks';

type P = {
  colSpan?: 10 | 7;
  controls: {
    hasTitleIcon?: boolean;
    seeAll?: { limit?: number; onClick?: () => void };
    title: ReactNode;
    titleLevel?: 2 | 4;
  };
  description?: ReactNode;
  emptyState?: ReactNode;
  getPathToVideoDetail: (id: string) => string;
  onEmptyState?: (isEmpty: boolean) => void;
  query?: { filter?: VideosListFilter };
};

const VideosSlider = ({
  colSpan,
  controls: { hasTitleIcon, seeAll, title, titleLevel },
  description,
  emptyState,
  getPathToVideoDetail,
  onEmptyState,
  query,
}: P) => {
  const {
    query: { data, fetchNextPage, hasNextPage, isFetching, isLoading },
  } = useVideos({
    allowUnfeatured: Boolean(seeAll?.onClick),
    filter: query?.filter,
    pagination: { pageSize: 4 },
  });

  const videos = data?.pages.flatMap((videosPaginated) => videosPaginated.data);
  const videosTotal = data?.pages[0]?.total ?? 0;

  const isEmpty = useIsChannelEmpty(isLoading, videos);

  // TODO this hack is needed together with useEffect in default channels to set empty state correctly
  useEffect(() => {
    onEmptyState?.(isEmpty);
  }, [isEmpty, onEmptyState]);

  return (
    <Slider
      colSpan={colSpan}
      controls={{
        seeAll: { limit: seeAll?.limit, onClick: seeAll?.onClick, total: videosTotal },
        title,
        titleIcon: hasTitleIcon ? <Icon icon="video-line" /> : undefined,
        titleLevel,
      }}
      description={description}
      emptyState={emptyState}
      items={videos?.map((video) => ({
        children: <VideoCard getPathToVideoDetail={getPathToVideoDetail} video={video} />,
        key: `video-${video.id}`,
      }))}
      queryData={{
        fetchNextPage,
        hasNextPage,
        isFetching,
        isLoading,
      }}
    />
  );
};

export default VideosSlider;
